import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb } from 'semantic-ui-react'
import { reduxForm, getFormValues } from 'redux-form'
import { MainBodyContent } from 'components'
import { appLoading } from 'ducks/app'
import { getVMFormData, clearVMFormData, updateVM, getWorkflow } from 'ducks/vendorMaintenance'
import { validations, validateCase as vCase } from 'core/validate'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import { vmPath, vmEditPath } from 'routes'
import { 
  AccountingForm, 
  ApproveForm, 
  AttachmentForm, 
  CommentHistory, 
  GeneralForm, 
  PurchasingForm, 
  RequestForm 
} from '../Form'
import {
  CertificateAttachmentForm, 
} from '../../Suppliers/Form'
import { VendorMaintenanceContainer, VendorMaintenanceBody } from '../Form/styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'

import r from 'reactotron-react-js'

const VendorMaintenanceDetail = (props) => {
  const { formData, workflow, valueForm, username } = props

  useEffect(() => {
    // props.getHrmsMembers(true)
    props.getAllMembers(true)
    props.getVMFormData(props.match.params.id, props.history)
    props.getWorkflow(props.match.params.id)

    return () => {
      props.clearVMFormData()
    }
  }, [])

  useEffect(() => {
    if (props.formData.id) {
      let username = localStorage.getItem('username').toLowerCase()
      if (props.formData.status === 0) {
        if (props.formData.createdBy.toLowerCase() === username ) {
          props.history.push(vmEditPath(props.formData.id))
        }
      }

      if (props.formData.status === 5 && (username === props.formData.createdBy.toLowerCase() || username === props.formData.requesterUser.toLowerCase())) {
        props.history.push(vmEditPath(props.formData.id))
      }

      if (props.formData.status === 10 || props.formData.status === 11) {
        props.history.push(vmEditPath(props.formData.id))
      }
    }
  }, [props.formData])

  const censorData = () => {
    if (valueForm.accountGroup === 'ZEMP') {
      if (((valueForm.createdBy === username || 
            valueForm.requesterUser === username) || 
            valueForm.sn)) {
              // creater, requester and everyone has sn can action 
        return false
      }
      return true
    } else {
      return false
    }
  }

  return (
    <MainBodyContent 
      headerTitle={formData.documentNumber ? `Vendor Maintenance - ${formData.documentNumber}` : 'Vendor Maintenance'}
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'VM', content: 'Vendor Maintenance', link: true, onClick: () => props.history.push(vmPath) },
              { key: 'VMCreate', content: 'Detail', active: true }
            ]
          }
        />
      }
    >
      <VendorMaintenanceContainer>
        <DocumentStep documentDetail={formData} approvers={workflow.data} />
        <VendorMaintenanceBody>
          <form>
            <RequestForm isDisplay={true} change={props.change} valueForm={valueForm}/>
            <GeneralForm isDisplay={true} change={props.change} valueForm={valueForm} />
            {
              censorData() ? null :
              <React.Fragment>
                {
                  valueForm.purpose === 'block' || 
                  valueForm.purpose === 'copy' || 
                  valueForm.accountGroup === 'ZEMP' ? null :
                    <PurchasingForm isDisplay={true} valueForm={valueForm}/>
                }
                {
                  valueForm.purpose === 'block' || valueForm.purpose === 'copy' ? null :
                    <AccountingForm 
                      isDisplay={
                        valueForm.sn === undefined ||
                        valueForm.sn === null ||
                        valueForm.sn === ''
                      } 
                      change={props.change}
                      valueForm={valueForm}
                    />
                }
                {
                  valueForm.status === 2 ? <ApproveForm history={props.history} handleSubmit={props.handleSubmit} /> : null
                }
                {
                  valueForm.purpose === 'block' || !valueForm.isFromVendor? null : valueForm.vendorType=='company'?
                    <CertificateAttachmentForm change={props.change} valueForm={valueForm}/>:null
                }
                {
                  valueForm.purpose === 'block' || valueForm.purpose === 'copy' ? null :
                    <AttachmentForm isDisplay={true} change={props.change} valueForm={valueForm}/>
                }
              </React.Fragment>
            }
            {
              formData && formData.comments && formData.comments.length ? <CommentHistory /> : null
            }
          </form>
        </VendorMaintenanceBody>
      </VendorMaintenanceContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const vf = getFormValues('formVendorMaintenance')(state) || {}
  const fd = state.vendorMaintenance.formData.data

  const getValue = (key) => {
    return vf[key] !== undefined ? vf[key] : fd[key]
  }

  const initialValues = {
    id: fd.id,
    status: getValue('status'),
    title: getValue('title'),
    requesterUser: getValue('requesterUser'),
    requesterName: getValue('requesterName'),
    createdBy: getValue('createdBy'),
    documentDate: getValue('documentDate'),
    remark: getValue('remark'),
    purpose: getValue('purpose'),
    copyType: getValue('copyType'),
    vendorCode: getValue('vendorCode'),
    accountGroup: getValue('accountGroup'),
    companyCode: getValue('companyCode'),
    companyName: getValue('companyName'),
    companies: getValue('companies'),
    vendorType: getValue('vendorType'),
    vendorName1: getValue('vendorName1'),
    vendorName2: getValue('vendorName2'),
    vendorName3: getValue('vendorName3'),
    vendorName4: getValue('vendorName4'),
    searchName: getValue('searchName'),
    industry: getValue('industry'),
    standardIndustry: getValue('standardIndustry'),
    taxId: getValue('taxId'),
    isGovernment: getValue('isGovernment'),
    country: getValue('country'),
    province: getValue('province'),
    district: getValue('district'),
    subDistrict: getValue('subDistrict'),
    houseNumber: getValue('houseNumber'),
    buildingOrRoomNo: getValue('buildingOrRoomNo'),
    street: getValue('street'),
    postalCode: getValue('postalCode'),
    notRegisterRemark: getValue('notRegisterRemark'),
    vendorUsers: getValue('vendorUsers'),
    paymentTypeTransfer: getValue('paymentTypeTransfer'),
    paymentTypeCheque: getValue('paymentTypeCheque'),
    paymentTypeTtlc: getValue('paymentTypeTtlc'),
    vendorBanks: getValue('vendorBanks'),
    copyPurchasingOrg: getValue('copyPurchasingOrg'),
    usePurchasingView: getValue('usePurchasingView'),
    purchasingOrg: getValue('purchasingOrg'),
    orderCurrency: getValue('orderCurrency'),
    paymentTerms: getValue('paymentTerms'),
    salePerson: getValue('salePerson'),
    salePersonTelephone: getValue('salePersonTelephone'),
    incoterm: getValue('incoterm'),
    incotermsLocation: getValue('incotermsLocation'),
    grBasedInvoiceVerification: getValue('grBasedInvoiceVerification'),

    reconciliationAccount: getValue('reconciliationAccount'),
    sortKey: getValue('sortKey'),
    planningGroup: getValue('planningGroup'),
    accPaymentTerms: getValue('accPaymentTerms'),
    paymentMethod: getValue('paymentMethod'),
    paymentBlock: getValue('paymentBlock'),
    tradingPartner: getValue('tradingPartner'),
    previousAccount: getValue('previousAccount'),
    checkDoubleInvoice: getValue('checkDoubleInvoice'),
    payeeInDocument: getValue('payeeInDocument'),
    withholdingTaxs: getValue('withholdingTaxs'),
    branches: getValue('branches'),
    branchCode: getValue('branchCode'),
    branchDescription: getValue('branchDescription'),

    attachment01: getValue('attachment01'),
    attachment02: getValue('attachment02'),
    attachment03: getValue('attachment03'),
    attachment04: getValue('attachment04'),
    attachment05: getValue('attachment05'),
    attachment06: getValue('attachment06'),
    attachment07: getValue('attachment07'),
    attachment08: getValue('attachment08'),
    attachment09: getValue('attachment09'),
    attachment10: getValue('attachment10'),
    attachment11: getValue('attachment11'),
    attachment12: getValue('attachment12'),
    attachment13: getValue('attachment13'),
    attachment14: getValue('attachment14'),
    attachment15: getValue('attachment15'),
    attachment16: getValue('attachment16'),
    attachment17: getValue('attachment17'),

    sn: getValue('sn'),
    actions: getValue('actions'),
    submittedDate: getValue('submittedDate'),
    modifiedDate: getValue('modifiedDate'),

    purchasingViewLoaded: getValue('purchasingViewLoaded'),
    accountingViewLoaded: getValue('accountingViewLoaded'),

    centralBlock: getValue('centralBlock'),
    allPurchasingBlock: getValue('allPurchasingBlock'),
    blockCompanies: getValue('blockCompanies'),
    blockAllCompany: getValue('blockAllCompany'),
    isFromVendor: getValue('isFromVendor'),
    mobile: getValue('mobile'),
    telephone: getValue('telephone'),
    extension: getValue('extension'),
    website: getValue('website'),
    totalValueOfCurrentProject: getValue('totalValueOfCurrentProject'),
    totalValueOfCurrentProjectCurrency: getValue('totalValueOfCurrentProjectCurrency'),
    listDealer: getValue('listDealer'),
    typeOfBusiness: getValue('typeOfBusiness'),
    typeOfBusinessOther: getValue('typeOfBusinessOther'),
    typeOfVendor: getValue('typeOfVendor'),
    receiveEWht: getValue('receiveEWht')
  }

  const blockCompanies = getValue('blockCompanies') || []

  blockCompanies.forEach(c => {
    initialValues[`block_${c}`] = vf[`block_${c}`] !== undefined ? vf[`block_${c}`] : true
  })

  return ({
    username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '',
    valueForm: vf,
    formData: fd,
    attachmentGroups: state.vendorMaintenance.attachmentGroups,
    workflow: state.vendorMaintenance.workflow,
    initialValues
  })
}

const mapDispatchToProps = {
  getVMFormData,
  clearVMFormData,
  updateVM,
  appLoading,
  getWorkflow,
  getHrmsMembers,
  getAllMembers
}

const validate = (values) => {
  let errors = {}
  validations(values, 'title', [vCase.require], errors)
  validations(values, 'requesterUser', [vCase.require], errors)
  validations(values, 'documentDate', [vCase.require], errors)
  validations(values, 'purpose', [vCase.require], errors)
  validations(values, 'accountGroup', [vCase.require], errors)

  if (values.purpose && values.purpose === 'create') {
    if (values.purpose === 'create') {
      validations(values, 'companyCode', [vCase.require], errors)
    }

    if (values.purpose === 'change') {
    }

    if (values.purpose === 'copy') {
    }

    if (values.purpose === 'block') {
    }
  }

  validations(values, 'vendorType', [vCase.require], errors)
  validations(values, 'vendorName1', [vCase.require, vCase.maxLength40], errors)
  validations(values, 'vendorName2', [vCase.maxLength40], errors)
  validations(values, 'vendorName3', [vCase.maxLength40], errors)
  validations(values, 'vendorName4', [vCase.maxLength40], errors)

  validations(values, 'industry', [vCase.require], errors)
  if (values.accountGroup === 'ZFOV') {
    validations(values, 'taxId', [vCase.maxLength13], errors)
  } else {
    validations(values, 'taxId', [vCase.require, vCase.maxLength13], errors)
  }
  validations(values, 'country', [vCase.require], errors)
  validations(values, 'province', [vCase.require], errors)
  validations(values, 'district', [vCase.require], errors)
  validations(values, 'subDistrict', [vCase.require], errors)
  validations(values, 'houseNumber', [vCase.require, vCase.maxLength10], errors)
  validations(values, 'buildingOrRoomNo', [vCase.require, vCase.maxLength60], errors)
  validations(values, 'street', [vCase.maxLength40], errors)
  validations(values, 'postalCode', [vCase.require, vCase.maxLength10], errors)

  if (values.usePurchasingView) {
    validations(values, 'orderCurrency', [vCase.require], errors)
    validations(values, 'paymentTerms', [vCase.require], errors)

    if (values.incoterm !== undefined && values.incoterm !== '' && values.incoterm !== null) {
      validations(values, 'incotermsLocation', [vCase.require], errors)
    }
  }

  return errors
}

const VendorMaintenanceDetailForm = reduxForm({
  form: 'formVendorMaintenance',
  enableReinitialize: true,
  validate
})(VendorMaintenanceDetail)

export default connect(mapStateToProps, mapDispatchToProps)(VendorMaintenanceDetailForm)
